// extracted by mini-css-extract-plugin
export default {"container":"order-timeout-notifications_container__53930"};